import type {Component, Editor} from 'grapesjs';
import {POSTERMYWALL_DESCRIPTION_TEXT_TYPE} from '@FormMakerReact/components/postermywall-description-text/postermywall-description-text';
import {applyEntireDescriptionTextColor, getUniformDescriptionTextColor} from '@FormMakerReact/lib/form-maker-description-color-library';

export function applyColor(editor: Editor, savedRange: Range | undefined, color: string): void {
  const description = getSelectedDescription(editor);
  if (!description) {
    return;
  }

  if (!restoreColorSelection(description, savedRange)) {
    return;
  }

  editor.RichTextEditor.globalRte?.exec('foreColor', color);

  const uniformColor = getUniformDescriptionTextColor(description);
  if (uniformColor !== null) {
    applyEntireDescriptionTextColor(description, uniformColor);
    return;
  }

  syncDescriptionModelFromDom(description);
}

function syncDescriptionModelFromDom(description: Component): void {
  const descEl = description.getEl();
  if (!descEl) {
    return;
  }

  description.components(descEl.innerHTML, {silent: true});
}

function restoreColorSelection(description: Component, savedRange: Range | undefined): boolean {
  const descEl = description.getEl();
  const doc = descEl?.ownerDocument;
  const selection = doc?.getSelection();
  if (!descEl || !doc || !selection) {
    return false;
  }

  descEl.focus({preventScroll: true});

  const liveRange = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
  const liveInDesc = liveRange !== null && descEl.contains(liveRange.commonAncestorContainer);
  const savedInDesc = savedRange !== undefined && descEl.contains(savedRange.commonAncestorContainer);

  if (liveInDesc && !liveRange.collapsed) {
    return true;
  }

  if (savedInDesc && savedRange && !savedRange.collapsed) {
    return applyRange(selection, savedRange);
  }

  if (liveInDesc) {
    return true;
  }

  if (savedInDesc && savedRange) {
    return applyRange(selection, savedRange);
  }

  return false;
}

function applyRange(selection: Selection, range: Range): boolean {
  selection.removeAllRanges();
  selection.addRange(range);

  return true;
}

function getSelectedDescription(editor: Editor): Component | undefined {
  const selected = editor.getSelected();

  if (!selected || selected.get('type') !== POSTERMYWALL_DESCRIPTION_TEXT_TYPE) {
    return undefined;
  }

  return selected;
}
